<script lang="ts">
    import Vue from 'vue';
    import { Component } from 'vue-facing-decorator';
    import { CriterionTemplateReadModel } from "@Criteria/Hierarchies/Domain/readmodels";
    import { DiscreteScale } from '@Scales/Model';
    import { CriteriaLibraryViewModel } from '@Criteria/Hierarchies/Components/CriteriaLibrary';

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class CriteriaLibrary extends Vue
    {
        get vm(): CriteriaLibraryViewModel { return this.$props.viewModel as CriteriaLibraryViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }
        
        get initialized(): boolean { return this.vm.data != null; }
        get categories(): string[] { return this.vm.data?.CriteriaCategories ?? []; }
        get templates(): CriterionTemplateReadModel[] { return this.vm.data?.CriteriaTemplates ?? []; }
        get templatesView() { return this.selectedCategory ? this.templates.filter(a => a.Category === this.selectedCategory) : this.templates; }
        get categoryLabel() { return this.selectedCategory ? `Category: ${this.selectedCategory}` : "All templates"; }
        
        selectedCategory: string | null = null;
        
        emitCreateCriterion(rm: CriterionTemplateReadModel)
        { 
            this.$emit('create-criterion', this.vm.parentId, rm.AttributeId, rm.Name);
        }
        
        emitShowScale(scale: DiscreteScale) 
        { 
            this.$emit('show-scale', scale);
        }

        close() 
        { 
            this.vm.close(); 
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Criteria templates</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <h3 v-if="!initialized"><i class="fa fa-spinner fa-spin"></i> Loading... </h3>
                        <div v-if="initialized">
                            <div class="dropdown">
                                <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown">
                                    <span>{{categoryLabel}}</span>
                                </button>
                                <div class="dropdown-menu">
                                    <a class="dropdown-item" @click="selectedCategory = null">All templates</a>
                                    <h6 class="dropdown-header">Categories:</h6>
                                    <a class="dropdown-item" v-for="c in categories" @click="selectedCategory = c">{{c}}</a>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12" v-for="item in templatesView">
                                    <div class="card mt-3">
                                        <div class="card-header text-center">
                                            <span>{{item.Category || '&nbsp;'}}</span>
                                        </div>
                                        <div class="card-body" style="max-height: 250px; height: 250px; overflow-y: auto;">
                                            <h5 class="card-title">{{item.Name}}</h5>
                                            <p class="card-text">{{item.Description}}</p>
                                            <a class="text-primary" @click="emitShowScale(item.ScaleTemplate)" title="View scale template">
                                                <span>Default scale: {{item.ScaleTemplateName}}</span>
                                            </a>
                                        </div>
                                        <div class="card-footer text-center">
                                            <button :disabled="item.Used" class="btn btn-outline-secondary" @click="emitCreateCriterion(item)">
                                                {{ item.Used ? "Added" : "Create"}}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button @click="close" type="button" class="btn btn-outline-secondary">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
</style>